import { registerFeature } from "lib/features"
import { isEnabled } from "lib/@components/feature"
import { HeaderBarRight, ScheduleHeaderToolbar } from "slot-definitions"
import { ContentLanguageSelector } from "./content-language-selector"
import { ScheduleTranslationBadge } from "./schedule-translation-badge"

export const FEATURE_FLAG_CONTENT_TRANSLATION = registerFeature({
    numericalId: 20,
    id: "content-translation",
    name: "Content Translation",
    description: "AI-powered translation of schedule content into foreign languages with verification",
    readyForProduction: false,
})

HeaderBarRight.plug(
    <ContentLanguageSelector $lazy if={() => isEnabled(FEATURE_FLAG_CONTENT_TRANSLATION)} priority={200} />
)
ScheduleHeaderToolbar.plug(
    <ScheduleTranslationBadge $lazy if={() => isEnabled(FEATURE_FLAG_CONTENT_TRANSLATION)} priority={50} />
)
